import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { auth } from 'helpers/Firebase';
import { adminRoot, UserRole } from 'constants/defaultValues';
import { setCurrentUser } from 'helpers/Utils';
import endpoints from 'core/utils/endpoints';
import http from 'core/utils/http';
import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../contants';

import {
  loginUserSuccess,
  loginUserError,
  registerUserSuccess,
  registerUserError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
} from './actions';

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

const loginWithEmailPasswordAsync = (email, password) => {
  const apiUrl = endpoints.auth.login;
  const formValues = { email, password };
  return http()
    .post(apiUrl, formValues)
    .then((user) => user)
    .catch((error) => error);
};

function* loginWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;

  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
    if (!loginUser.error) {
      const item = { ...loginUser };
      setCurrentUser(item);
      localStorage.setItem('authToken', item.access_token);
      yield put(loginUserSuccess(item));
      history.push(adminRoot);
    } else {
      yield put(loginUserError(loginUser.error.message));
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

export function* watchRegisterUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

const registerWithEmailPasswordAsync = async (formValues) => {
  const apiUrl = endpoints.auth.register;
  return http()
    .post(apiUrl, formValues)
    .then((user) => user)
    .catch((error) => error);
};

function* registerWithEmailPassword({ payload }) {
  const formValues = payload.user;
  const { history } = payload;

  try {
    const registerUser = yield call(registerWithEmailPasswordAsync, formValues);
    if (!registerUser.error) {
      const item = {
        ...registerUser,
        role: UserRole.Admin,
      };
      setCurrentUser(item);
      localStorage.setItem('authToken', item.token);
      yield put(registerUserSuccess(item));
      history.push(adminRoot);
    } else {
      yield put(registerUserError(registerUser.error.message));
    }
  } catch (error) {
    yield put(registerUserError(error));
  }
  // return yield call(function* () {
  // });
}

export function* watchLogoutUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  await auth
    .signOut()
    .then((user) => user)
    .catch((error) => error);
  history.push(adminRoot);
};

function* logout({ payload }) {
  const { history } = payload;
  setCurrentUser();
  yield call(logoutAsync, history);
}

export function* watchForgotPassword() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = (emailId) => {
  const apiUrl = endpoints.auth.forgetPassword;
  const formValues = { email: emailId };
  // eslint-disable-next-line no-return-await
  return http()
    .post(apiUrl, formValues)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

function* forgotPassword({ payload }) {
  const { email } = payload.forgotUserMail;
  try {
    const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
    if (!forgotPasswordStatus.error) {
      yield put(forgotPasswordSuccess('success'));
    } else {
      yield put(forgotPasswordError(forgotPasswordStatus.error.message));
    }
  } catch (error) {
    yield put(forgotPasswordError(error.error.message));
  }
}

export function* watchResetPassword() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = (
  resetPasswordCode,
  newPassword,
  newPasswordAgain
) => {
  const apiUrl = endpoints.auth.resetPassword;
  const formValues = {
    token: resetPasswordCode,
    password: newPassword,
    password_confirmation: newPasswordAgain,
  };
  return http()
    .post(apiUrl, formValues)
    .then((res) => res)
    .catch((err) => err);
};

function* resetPassword({ payload }) {
  const { newPassword, newPasswordAgain, resetPasswordCode, history } = payload;
  try {
    const resetPasswordStatus = yield call(
      resetPasswordAsync,
      resetPasswordCode,
      newPassword,
      newPasswordAgain
    );
    if (resetPasswordStatus) {
      yield put(resetPasswordSuccess('success'));
      history.push('/user/login');
    } else {
      yield put(resetPasswordError(resetPasswordStatus.message));
    }
  } catch (error) {
    yield put(resetPasswordError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchForgotPassword),
    fork(watchResetPassword),
  ]);
}
